<template>
  <b-overlay
    :show="loader.pagina"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <!-- content -->
      <h2>Documentos Relevantes</h2>
      <hr>
      <br>
      <b-row class="kb-search-content-info match-height">
        <!-- list dinamic -->
        <b-col
          v-for="item in kbnoticias"
          :id="'option-'+item.id"
          :key="item.id"
          md="3"
          sm="6"
        >
          <b-card
            :class="item.cls"
            :img-src="require('@/assets/images/illustration/' + item.img)"
            img-top
            @click="noticia(item.goahead)"
          >
            <h4>{{ item.title }}</h4>
            <b-card-text class="mt-1">
              {{ item.desc }}
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <hr>
    </div>
  </b-overlay>
</template>

<script>
import { getData } from '@core/utils/http/general'
import {
  BRow, BCol, BCard, BCardText, VBModal, BOverlay,
} from 'bootstrap-vue'
import store from '@/store'
import {
  isEmptyObject,
} from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'DashAlumno',
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BOverlay,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      loader: {
        pagina: false,
      },
      kbnoticias: [],
    }
  },
  computed: {
    getSession() {
      if (!isEmptyObject(this.$store.getters['cuenta/getSession'])) return this.$store.getters['cuenta/getSession']
      return {}
    },
    getAccount() {
      return this.$store.getters['cuenta/getAccount']
    },
  },
  created() {
    this.get_data()
  },
  methods: {
    noticia(links) {
      window.open(links, '_blank')
    },
    get_data() {
      this.loader.pagina = true
      getData({ action: 6, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) this.kbnoticias = response.data.data
          else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Sección en construcción`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.pagina = false
        }).catch(err => {
          this.loader.pagina = false
          this.$bvToast.toast(err, {
            title: 'Error, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
</style>
